import React, { useEffect, useState } from "react";
import TotalCountCard from "./total-count-card";
import { useDispatch } from "react-redux";

import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";

import { Link, useLocation, useNavigate } from "react-router";
import { Navigate } from "react-router-dom";
import FunnelChart from "../common/chart/funnelChart";
import LineChart from "../common/chart/lineChart";
import LineChartV2 from "../common/chart/lineChartV2";
import ChartHeader from "../common/chart/chartHeader";
import { funnelChartColors } from "../../js/api/constants";

import AllowedAccess from "../../guards/AllowedAccess";
import PermissionList from "../../guards/PermissionList";
const TotalCount = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [funnelData, setFunnelData] = useState([]);
  const [studyData, setStudyData] = useState([]);
  const [funnelChartLoading, setFunnelChartLoading] = useState(true);
  const [studyChartLoading, setStudyChartLoading] = useState(true);

  const refreshPage = () => {
    navigate(0); // Pass the current path for navigation
  };
  const goToLogin = () => {
    navigate("/login");
  };
  const [dataValue, setData] = useState({
    totalPatients: 0,
    totalTrials: 0,
    totalClinics: 0,
    totalRecruiters: 0,
  });

  // useEffect(() => {
  //   const { totalPatients, totalTrials, totalClinics, totalRecruiters } = dataValue;
  //   if (totalPatients === 0 && totalTrials === 0 && totalClinics === 0 && totalRecruiters === 0) {
  //     fetchDashboardData();
  //   }
  // }, []);

  async function fetchDashboardData() {
    setLoading(true);

    try {
      const response = await axios.get(ENDPOINTS.DASHBOARD.GET_COUNT);
      setData(response.data.data); // Set the data from the API response
      setLoading(false);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  }

  const funnelChartData = async (filters) => {
    setFunnelChartLoading(true);
    const params = {};

    if (filters.filterType) {
      params.filterType = filters.filterType;
    }
    if (filters.fromDate) {
      params.fromDate = filters.fromDate;
    }
    if (filters.toDate) {
      params.toDate = filters.toDate;
    }
    if (filters.trialID) {
      params.trialID = filters.trialID;
    }
    if (filters.clinicalInfoID) {
      params.clinicalInfoID = filters.clinicalInfoID;
    }

    try {
      const response = await axios.get(ENDPOINTS.DASHBOARD.FUNNEL_ANALYTICS, {
        params: params,
      });
      if (response.data && response.data.data.length > 0) {
        let data = response.data.data.map((item) => {
          return {
            stage: item.statusName,
            count: item.count,
            width: `${item.percentage}`,
            color: funnelChartColors[item.statusName] || "#4B5563CC",
          };
        });

        let totalCount = response.data.data.reduce(
          (sum, item) => sum + item.count,
          0
        );

        data.unshift({
          stage: "Total",
          count: totalCount,
          width: "100",
          color: "#4B5563CC",
        });

        setFunnelData(data);
      } else {
        setFunnelData([]);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setFunnelChartLoading(false);
    }
  };

  const studyChartData = async (filters) => {
    setStudyChartLoading(true);
    const params = {};

    if (filters.filterType) {
      params.filterType = filters.filterType;
    }
    if (filters.fromDate) {
      params.fromDate = filters.fromDate;
    }
    if (filters.toDate) {
      params.toDate = filters.toDate;
    }
    if (filters.trialID) {
      params.trialID = filters.trialID;
    }
    if (filters.clinicalInfoID) {
      params.clinicalInfoID = filters.clinicalInfoID;
    }

    try {
      const response = await axios.get(ENDPOINTS.DASHBOARD.STUDY_ANALYTICS, {
        params: filters,
      });

      if (response.data && response.data.data.length > 0) {
        const new_data = response.data.data.map((item) => {
          return {
            name: item.trialName,
            percentage: item.patientPercentage,
            attributes: item.patientDetailsList,
            attributesCount: item.patientCount,
            data: item, // Assuming dataPoints is an array of { date, value
          };
        });

        setStudyData(new_data);
      } else {
        setStudyData([]);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setStudyChartLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 p-4 pt-5">
        <AllowedAccess permissions={[PermissionList.root.admin_location]}>
          <Link to="/locations">
            <TotalCountCard
              title="Locations"
              bgColor="bg-[#EFF1FF]"
              count={dataValue.totalClinics}
              loading={loading}
            />
          </Link>
        </AllowedAccess>

        <AllowedAccess permissions={[PermissionList.root.trials_hub]}>
          <Link to="/trials">
            <TotalCountCard
              title="Trials"
              count={dataValue.totalTrials}
              icondivBgColor="bg-[#ECDEFF]"
              bgColor="bg-[#F5EEFF]"
              borderColor="border-[#C8D6E6]"
              iconBgColor="bg-[#AE78FB]"
              iconColor="text-[#ECDEFF]"
              loading={loading}
            />
          </Link>
        </AllowedAccess>

        <AllowedAccess permissions={[PermissionList.root.patient]}>
          <Link to="/patients">
            <TotalCountCard
              title="Patients"
              count={dataValue.totalPatients}
              icondivBgColor="bg-[#FDECD2]"
              bgColor="bg-[#FEF6EA]"
              borderColor="border-[#C8D6E6]"
              iconBgColor="bg-[#FBBD61]"
              iconColor="bg-[#FBBD61]"
              loading={loading}
            />
          </Link>
        </AllowedAccess>

        <AllowedAccess permissions={[PermissionList.root.admin_recruiter]}>
          <Link to="/recruiters">
            <TotalCountCard
              title="Recruiters"
              count={dataValue.totalRecruiters}
              icondivBgColor="bg-[#FFDAD1]"
              bgColor="bg-[#FFF2EF]"
              borderColor="border-[#C8D6E6]"
              iconBgColor="bg-[#EE8062]"
              iconColor="text-yellow-600"
              loading={loading}
            />
          </Link>
        </AllowedAccess>
      </div>

      <div className="p-4 pt-0">
        <AllowedAccess permissions={[PermissionList.trials_hub.trial_view]}>
          <div className="flex justify-between items-center mb-4 gap-4">
            <div className="flex-1 rounded-lg border border-blue-100 font-mont p-4 px-6 h-[460px]">
              <ChartHeader
                title={"Patient Funnel Analytics"}
                onChange={(val) => {
                  const values = {
                    filterType: "custom",
                    fromDate: val.dateRange.startDate,
                    toDate: val.dateRange.endDate,
                    clinicalInfoID:
                      val.selectedLocations.length > 0
                        ? val.selectedLocations.join(",")
                        : null,
                    trialID:
                      val.selectedStudies.length > 0
                        ? val.selectedStudies.join(",")
                        : null,
                  };
                  funnelChartData(values);
                }}
              />
              <FunnelChart
                isLoading={funnelChartLoading}
                data={funnelData || []}
              />
            </div>

            <div className="flex-1 rounded-lg border border-blue-100 font-mont p-4 px-6 h-[460px]">
              <ChartHeader
                title={"Action Required by Study"}
                onChange={(val) => {
                  const values = {
                    filterType: "custom",
                    fromDate: val.dateRange.startDate,
                    toDate: val.dateRange.endDate,
                    clinicalInfoID:
                      val.selectedLocations.length > 0
                        ? val.selectedLocations.join(",")
                        : null,
                    trialID:
                      val.selectedStudies.length > 0
                        ? val.selectedStudies.join(",")
                        : null,
                  };
                  studyChartData(values);
                }}
              />
              <LineChartV2
                isLoading={studyChartLoading}
                label="Patients"
                data={studyData}
                onAttrClick={(val) => {
                  navigate(`/conversation-patients/${val.patientTrialJuncID}`, {
                    replace: true,
                  });
                }}
                onTitleClick={(item) => {
                  navigate(
                    `/trial-statuses/action_required?trial_id=${item.data.trialID}&&status=Action Required&&sorting=desc&&trial_name=${item.data.trialName}`
                  );
                }}
              />
            </div>
          </div>
        </AllowedAccess>
        {/* <div className='flex justify-between items-center mb-4 gap-4'>
          <div className="flex-1 rounded-lg border border-blue-100 font-mont p-4 px-6 h-[400px]">
            <ChartHeader title={'Action Required by Study'} onChange={(val) => {
              console.log('Funnel Chart Filters changed', val)
            }}
            />
            <LineChartV2 data={studyData} />
          </div>

          <div className="flex-1 rounded-lg border border-blue-100 font-mont p-4 px-6 h-[400px]">
          
          </div>


        </div> */}
      </div>
    </>
  );
};

export default TotalCount;
